/**
 * 订单相关请求里的 `src` 参数（与历史 `anchor ? (anchor.src ? anchor.src : 2) : 4` 一致）
 */
export default function orderRequestAnchorSrc(anchor) {
  if (!anchor) {
    return 4;
  }
  return anchor.src ? anchor.src : 2;
}